import React from 'react';
import { useSelector } from "react-redux";
import { selectPermissions } from "../../../../util/store/selectors";
import { ACTION } from "../../../../util/varibles/permission";
import MapType from "../../_components/MapType";
import SearchMarker from "../../_components/SearchMarker";
import TrackVessel from "../../_components/TrackVessel";
import styles from '../style.module.scss';

const TopControl: React.FC = () => {
    const [canTrackVessel, canSearch, canChangeMapStyle] = useSelector(selectPermissions([
        ACTION.DASHBOARD.TRACKING_VESSEL,
        ACTION.DASHBOARD.SEARCH,
        ACTION.DASHBOARD.MAP_STYLE,
    ]));

    return <div className={styles.controlTop}>
        {canTrackVessel && <TrackVessel />}
        {canSearch && <SearchMarker />}
        {canChangeMapStyle && <MapType />}
    </div>;
};

export default TopControl;
